<div class="py-2 pt-md-0 pb-md-4" data-e2e="contract-item">
  @if (icon) {
  <div>
    <img alt="" [src]="icon" />
  </div>
  }
  <div class="row">
    <div class="col-12 col-md-6 col-lg-5">
      <h2 class="h3 mb-0" data-e2e="item-title">{{activeContractViewModel?.offerName}}</h2>
      @if (activeContractViewModel?.member) {
      <div class="text-smagenta1 font-weight-bold mt-1" data-e2e="item-member">
        {{activeContractViewModel.member.displayName}}
      </div>
      }
      <div class="lead text-gray3 py-0" data-e2e="item-offer">{{activeContractViewModel?.detail}}</div>
      @if (activeContractViewModel?.delegation) {
      <div class="lead text-gray3 py-0" data-e2e="item-holder">
        {{"dashboard.bills.delegation" | translate}}{{activeContractViewModel.delegation}}
      </div>
      } @if (activeContractViewModel?.installationCity) {
      <div class="lead text-gray3 py-0" data-e2e="item-installation-city">
        {{activeContractViewModel.installationCity}}
      </div>
      } @if (activeContractViewModel?.koContract && !activeContractViewModel?.koContract?.hideButtonKoContract) {
      <div class="alert-item alert-container alert-warning mt-2" role="alert">
        <p class="alert">
          <span class="alert-icon icon-Warning-important" aria-hidden="true"></span>
          <span class="text-mw">{{activeContractViewModel?.koContract?.textKoContract}}</span>
        </p>
      </div>
      } @if (!isVimEligible && activeContractViewModel !== null && activeContractViewModel.isFamilyEligible &&
      !activeContractViewModel.member) {
      <a
        [href]='"dashboard.bills.whoUseContract.link" | translate | link: ParamsUtils.cidMap(activeContractViewModel.cid) | async'
        (click)="openWhoUseContract();false"
        class="o-link-arrow"
        data-e2e="whoUseContract"
      >
        {{"dashboard.bills.whoUseContract.label" | translate}}</a
      >
      }
    </div>
    <div class="col-12 col-md-6 col-lg-7 mt-1 mt-md-0">
      @if (activeContractViewModel?.koContract?.hideButtonKoContract) {
      <div class="alert-item alert-container" [ngClass]="this.alertTheme" role="alert">
        <p class="alert">
          <span class="alert-icon" [ngClass]="this.iconTheme" aria-hidden="true"></span>
          <span class="text-mw">{{activeContractViewModel.koContract.textKoContract}}</span>
        </p>
        @if (activeContractViewModel.koContract.linkLabel) {
        <div class="alert-content">
          <a
            [href]="activeContractViewModel.koContract.link | link | async"
            (click)="openInprogressLink();false"
            class="o-link-arrow"
            >{{inprogressLinkLabel}}</a
          >
        </div>
        }
      </div>
      } @if ((!activeContractViewModel?.koContract || !activeContractViewModel?.koContract.hideButtonKoContract)) { @if
      (activeContractViewModel?.billItem?.lastBillStatus) {
      <div class="h3 text-primary mb-0" data-e2e="item-bill-amount">
        {{activeContractViewModel?.billItem?.lastBillAmount}}
      </div>
      <div class="lead text-gray3 mb-1 mb-md-0" data-e2e="item-bill-date">
        {{"dashboard.bills.billText" | translate}} {{activeContractViewModel?.billItem?.lastBillDate | date:'dd MMMM
        yyyy'}}
      </div>
      } @else {
      <p class="alert alert-info no-bill mb-0" role="alert" data-e2e="alert-no-bill">
        <span class="alert-icon icon-info"></span>
        <span class="text-mw"> {{"dashboard.bills.noBillText" | translate}}</span>
      </p>
      } @if (activeContractViewModel?.suspendedContract) {
      <crossroadSuspendedAlert
        [displayButton]="true"
        [viewModel]="activeContractViewModel.suspendedContract"
        [cid]="activeContractViewModel.cid"
      >
      </crossroadSuspendedAlert>
      } @if (activeContractViewModel?.billItem?.lastBillStatus || activeContractViewModel?.type !== 'mobilePrepaid') {
      <div class="d-flex justify-content-center justify-content-sm-start">
        <a
          class="btn btn-secondary mt-1 mt-md-2"
          data-e2e="item-link"
          [href]="billLink | link: ParamsUtils.cidMap(activeContractViewModel.cid) | async"
          (click)="openBill();false"
        >
          {{labelButton}}</a
        >
      </div>
      } }
    </div>
  </div>
</div>
